var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-block"},[_c('log',{attrs:{"client":_vm.client}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('i',{staticClass:"fa fa-info-circle mr-05"}),_vm._v(" Historique ")])
}]

export { render, staticRenderFns }